import { render } from "./BasicInput.vue?vue&type=template&id=687e2ebf&scoped=true&ts=true"
import script from "./BasicInput.vue?vue&type=script&lang=ts"
export * from "./BasicInput.vue?vue&type=script&lang=ts"

import "./BasicInput.vue?vue&type=style&index=0&id=687e2ebf&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-687e2ebf"]])

export default __exports__